<script>
import Badge from '@phoenix/mixins/components/checkout/summary/Badge';

export default {
  mixins: [Badge],
};
</script>

<template>
  <span ref="badge" data-cy="cart-summary-badge" :class="{ hidden: isHidden }">
    {{ countFromCookie }}
  </span>
</template>
